import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/modals-deduction-explanation';

const mainimage = '/Images/deduction1.webp';

const sections = [
  { label: "Exercises", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "deduction" },
];

const ModalsDeduction = () => (
  <GrammarPageLayout
    level="B2"
    title="Modals Deduction"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Modals of Deduction Exercises"
    seoDescription="Make logical guesses about present and past using must, might, can't. B2 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default ModalsDeduction;

